import Vue from 'vue'
///对日期进行格式化
Vue.prototype.$DateFormat = function (utcDate, format, isUtc) {
  var date;
  if (typeof (utcDate) === 'string') {
    date = new Date(utcDate);
  } else if (utcDate instanceof Date) {
    date = utcDate;
  } else {
    return "";
  }
  if (format == null || format.length <= 0) {
    format = "yyyy-MM-dd HH:mm:ss";
  }
  var numberFun = function (num) {
    return num < 10 ? '0' + num : '' + num;
  }
  var _;
  if (isUtc === true) {
    _ = {
      "yyyy": date.getUTCFullYear(),
      "MM": numberFun(date.getUTCMonth() + 1),
      "M": (date.getUTCMonth() + 1) + "",
      "dd": numberFun(date.getUTCDate()),
      "d": date.getUTCDate() + "",
      "HH": numberFun(date.getUTCHours()),
      "H": date.getUTCHours() + "",
      "mm": numberFun(date.getUTCMinutes()),
      "m": date.getUTCMinutes() + "",
      "ss": numberFun(date.getUTCSeconds()),
      "s": date.getUTCSeconds() + "",
    };
  } else {
    _ = {
      "yyyy": date.getFullYear(),
      "MM": numberFun(date.getMonth() + 1),
      "M": (date.getMonth() + 1) + "",
      "dd": numberFun(date.getDate()),
      "d": date.getDate() + "",
      "HH": numberFun(date.getHours()),
      "H": date.getHours() + "",
      "mm": numberFun(date.getMinutes()),
      "m": date.getMinutes() + "",
      "ss": numberFun(date.getSeconds()),
      "s": date.getSeconds() + "",
    };
  }
  var result = format;
  for (var key in _) {
    var s = _[key] + "";//.replace(/NaN/g,"00")
    result = result.replace(key, s.replace(/NaN/g, "00"));
  }
  return result;
};
Vue.prototype.$roundAmount = function (amount) {
  ///格式化金额，
  ///20.11 => 20.10
  ///20.13 => 20.15
  ///20.16 => 20.15
  ///20.18 => 20.20
  //先保留两位小数
  amount = parseFloat(amount).toFixed(3);
  let a = amount.substr(0,amount.indexOf(".")+3);
  let a1 = a.substring(0, a.length - 1);
  let a2 = a.substring(a.length - 1, a.length);
  let amount1 = parseFloat(a1);
  let amount2 = parseInt(a2);
  let amount3 = 0;
  if (amount2 < 3) {
    amount3 = 0;
  } else if (amount2 >= 8) {
    amount3 = 0.1;
    
  } else {
    amount3 = 0.05;
    
  }
  let amount4 = ((amount1 + amount3) * 100) / 100;
  amount4=amount4.toString().substr(0,amount.indexOf(".")+3)
  return amount4*1;
}
